export const MENTOR_NEW_BOOKING_TABS = {
  old_appointment: {
    id: 'old_appointment',
    title: 'Book Appointment',
  },
  appointment: {
    id: 'appointment',
    title: 'Book Appointment (Beta)',
  },
  patientReports: {
    id: 'patientReport',
    title: 'Treatment History',
  },
  patientHistory: {
    id: 'patientHistory',
    title: 'Patient History',
  },
  //   invoice: {
  //     id: 'invoice',
  //     title: 'Invoice',
  //   },
  //   payment: {
  //     id: 'payment',
  //     title: 'Payment',
  //   },
}

export const MENTOR_NEW_BOOKING_TABS_LIST = Object.values(MENTOR_NEW_BOOKING_TABS)
